/**
 * As of 20/Jun, the first three routes are the old way of doing things.
 * They've been superseded by Sam's new, more simple approach.
 */
export default [
    {
        name: 'warehouse.returns.process.index',
        path: '/warehouse/process/returns',
        component: () => import("@/views/modules/warehouse/returns/process/List"),
    },
    {
        name: 'warehouse.returns.receive.index',
        path: '/warehouse/receive/returns',
        component: () => import("@/views/modules/warehouse/returns/goods-in/FindItem"),
    },
    {
        name: 'warehouse.returns.amazon.update',
        path: '/warehouse/returns/fba/:itemReturnId',
        component: () => import("@/views/modules/warehouse/returns/goods-in/Process"),
    },

    // new way of doing things
    {
        name: 'warehouse.returns.locations',
        path: '/warehouse/returns/locations',
        component: () => import("@/views/modules/warehouse/returns/new/ReturnLocationsList"),
    },
    {
        name: 'warehouse.returns.location.items',
        path: '/warehouse/returns/location/:locationId/items',
        component: () => import("@/views/modules/warehouse/returns/new/ItemList"),
    }

]
